export const LISTING_PROFILE_WIDGET_KEY = {
  address: 'address',
  attention: 'needs-attention',
  createdUpdated: 'created-updated',
  performance: 'performance',
  portalLinks: 'portal-publications',
  publishing: 'publishing',
}

export const LISTING_PROFILE_DEFAULT_WIDGET_LIST_ORDER = [
  LISTING_PROFILE_WIDGET_KEY.attention,
  LISTING_PROFILE_WIDGET_KEY.performance,
  LISTING_PROFILE_WIDGET_KEY.publishing,
  LISTING_PROFILE_WIDGET_KEY.portalLinks,
  LISTING_PROFILE_WIDGET_KEY.address,
  LISTING_PROFILE_WIDGET_KEY.createdUpdated,
]
